<p-dialog
  [closable]="false"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [visible]="true"
>
  <ng-template #header>
    <header class="confirm-dialog">
      @if (title) {
        <h4 [innerHTML]="title"></h4>
      }
    </header>
    <a
      role="button"
      tabindex="0"
      aria-hidden="true"
      (click)="dismiss()"
      class="p-dialog-titlebar-icon ui-dialog-titlebar-close"
    >
      <span class="pi pi-times"></span>
    </a>
  </ng-template>
  <p [innerHTML]="message | safeHtml"></p>
  <div class="p-dialog-buttonpane ui-helper-clearfix">
    <button pButton class="w-md" data-cy="confirm-yes" (click)="dismiss()">
      OK
    </button>
  </div>
</p-dialog>
